import swal from './swal';

const uploadBackdropLimitSize = 10; // 限制上传舞台（背景）的大小(Mb)

const uploadSpriteLimitSize = 10; // 限制上传角色的大小(Mb)

const uploadSoundLimitSize = 20; // 限制上传声音的大小(Mb)

const recordSoundLimitSize = 20; // 限制录制声音的大小(Mb)

const uploadExceedAlert = (limitSize, actualSize) => {
    const defaultErrorMessage = '上传失败，文件大小超过限制！';
    const getErrorMessage = `请上传小于${limitSize}M的文件，当前文件大小为${actualSize}M`;
    swal.swal(defaultErrorMessage, getErrorMessage, 'error');
};

export {
    uploadBackdropLimitSize,
    uploadSpriteLimitSize,
    uploadSoundLimitSize,
    recordSoundLimitSize,
    uploadExceedAlert
};
